import { DomainRuleError } from "../errors.js";
import { defineMachine } from "../state-machine.js";
/** Order status (docs/06-db-schema.md, trade.orders.status). Money moves on schedule items, not here. */
export const order = defineMachine({
    name: "order",
    states: ["awaiting_payment", "in_progress", "awaiting_confirmation", "completed", "cancelled"],
    events: [
        "first_payment",
        "cancel",
        "payment_window_lapsed",
        "delivered",
        "cancellation_agreed",
        "confirm_receipt",
        "confirmation_timeout",
        "refunded_in_full",
    ],
    initial: "awaiting_payment",
    transitions: {
        awaiting_payment: {
            first_payment: "in_progress",
            cancel: "cancelled",
            payment_window_lapsed: "cancelled",
        },
        in_progress: {
            delivered: "awaiting_confirmation",
            cancellation_agreed: "cancelled",
            refunded_in_full: "cancelled",
        },
        awaiting_confirmation: {
            confirm_receipt: "completed",
            confirmation_timeout: "completed",
            refunded_in_full: "cancelled",
        },
        completed: {},
        cancelled: {},
    },
});
/** Fulfilment progress, tracked beside the order status. */
export const fulfilment = defineMachine({
    name: "fulfilment",
    states: ["not_shipped", "partially_shipped", "shipped", "delivered"],
    events: ["ship_part", "ship_rest", "ship_all", "deliver"],
    initial: "not_shipped",
    transitions: {
        not_shipped: { ship_part: "partially_shipped", ship_all: "shipped" },
        partially_shipped: { ship_part: "partially_shipped", ship_rest: "shipped" },
        shipped: { deliver: "delivered" },
        delivered: {},
    },
});
/** One payment schedule item: deposit, balance, or the full amount. */
export const scheduleItem = defineMachine({
    name: "schedule-item",
    states: ["not_due", "due", "paid", "released", "partially_refunded", "refunded", "cancelled"],
    events: ["become_due", "pay", "release", "refund_part", "refund_rest", "cancel"],
    initial: "not_due",
    transitions: {
        not_due: { become_due: "due", cancel: "cancelled" },
        due: { pay: "paid", cancel: "cancelled" },
        paid: { release: "released", refund_part: "partially_refunded", refund_rest: "refunded" },
        partially_refunded: { release: "released", refund_rest: "refunded" },
        released: {},
        refunded: {},
        cancelled: {},
    },
});
const ESCROW_ONLY = ["release", "refund_part", "refund_rest"];
/**
 * Moves a schedule item, refusing escrow actions on items paid by the interim bank transfer:
 * those were never held, so the platform can neither release nor refund them (ADR 0005).
 */
export function transitionScheduleItem(item, event) {
    if (item.protection === "none" && ESCROW_ONLY.includes(event)) {
        throw new DomainRuleError("INVALID_TRANSITION", `schedule-item: "${event}" needs an escrow hold; this item was paid by bank transfer`);
    }
    return scheduleItem.transition(item.status, event);
}
/** Receipt cannot be confirmed, by the buyer or by timeout, while an after-sales case is open (AFS-4). */
export function assertCanConfirmReceipt(current) {
    if (current.openCaseId !== null) {
        throw new DomainRuleError("CASE_OPEN", "An open after-sales case blocks confirmation and release");
    }
    if (!order.can(current.status, "confirm_receipt")) {
        throw new DomainRuleError("INVALID_TRANSITION", `order: cannot confirm receipt in state "${current.status}"`);
    }
}
//# sourceMappingURL=order.machine.js.map